import { createContext } from "react";

/**
 * A slot in the lesson's fixed bottom panel, just above its action button.
 * A step portals into it what belongs at the foot of the screen, as a phone's
 * own keyboard does. null outside a lesson: the step renders it in place.
 */
export const LessonDock = createContext<Dock | null>(null);

export interface Dock {
	el: HTMLElement;
	/**
	 * The bottom panel's height once the page's foot has grown to match it:
	 * an effect that scrolls against the dock re-runs on it, after the page
	 * is tall enough to scroll that far.
	 */
	height: number;
}
